import { useEffect } from "react";
import { Card } from "antd";
import { t } from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import AppConfig from "../../core/service/AppConfig";
import NotificationSettingsForm from "./NotificationSettingsForm";

export default function NotificationSettingsApp() {
    useEffect(() => {
        document.title = `${t('Notification Settings')} - ${AppConfig.getHisTitle()}`
    }, []);

    return (
        <SimpleLayout fullWidth={true}>
            <Card title={t('Notification Settings')}>
                <NotificationSettingsForm />
            </Card>
        </SimpleLayout>
    )
}
